module.exports = __webpack_public_path__ + "static/media/arawd.dff8aafc.svg";